var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-width:2px;}")),React.createElement("g",{"transform":"translate(-263.5 -768)","key":1},[React.createElement("path",{"d":"M4.5,0,9,6H0Z","transform":"translate(287 768) rotate(90)","key":0}),React.createElement("line",{"className":"a","x2":"18","transform":"translate(263.5 772.5)","key":1})])]);
}

Arrow.defaultProps = {"width":"23.5","height":"9","viewBox":"0 0 23.5 9"};

module.exports = Arrow;

Arrow.default = Arrow;
